import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import * as styles from './style/index.scss'
import EmptyImg from '@assets/img/empty2.png'
import {FormattedMessage} from 'react-intl'
import {Button} from 'antd-mobile'

interface NoInfoProps {
    messageId: string
    hasButton?: boolean
    btnTextMessageId?: string
    handleClick?: () => void
}

class NoInfo extends ComponentExt<NoInfoProps> {
    constructor(props) {
        super(props)
    }

    render() {
        const {messageId, hasButton = true, btnTextMessageId} = this.props
        return (
            <section className={styles.noInfoWrap}>
                <img src={EmptyImg} className={styles.emptyImg}/>
                <p className={styles.message}>
                    <FormattedMessage id={messageId}/>
                </p>
                {
                    hasButton &&
                    <Button className={styles.btn} onClick={this.props.handleClick}>
                        <FormattedMessage id={btnTextMessageId}/>
                    </Button>
                }
            </section>
        )
    }
}

export default NoInfo
